module.exports = __webpack_public_path__ + "static/media/barr-t1.50097e68.svg";